/* eslint-disable max-len */
import React from 'react';
import { Button, Form as AntForm } from 'antd';
import classNames from 'classnames';

import { icons } from '../../../constants';
import { SearchButton, Icon } from '..';

import styles from './SearchForm.module.scss';


/**
 *

fields = [

            <AntForm.Item help={ formik.touched[formFields.REVIEWED] && formik.errors[formFields.REVIEWED] }>
            <LabeledSelect
              label={ t('fields.reviewed.label') }
              id={ formFields.REVIEWED }
              style={{ outline: 'none' }}
              value={ formik.values[formFields.REVIEWED] }
              onChange={ formik.handleChange }
            />
          </AntForm.Item>
]
 */
export const Form = ({ onSearch, onReset, fields = [], id }) => (
  <AntForm
    data-testid={ id }
    className={ styles.card }
    onKeyPress={ e => {
      if (e.key === 'Enter') {
        onSearch();
      }
    } }
  >
    <div
      className={ classNames(
                  styles.form,
                  fields.length < 4 && styles.singlerow,
                  fields.length === 1 && styles.singleField,
                  fields.length === 4 && styles.fourFields,
                  fields.length > 9 && styles.fourCols
      ) }
    >
      {fields.map(field => field)}
    </div>
    <div className={ styles.searchButton }>
      <SearchButton id="searchButton" onClick={ onSearch } />
      {onReset && (
        <Button shape="circle" onClick={ onReset }>
          <Icon
            svg={ icons.CROSS }
            svgProps={{
                              height: 20,
                              width: 20
            }}
            style={{
                              fill: 'red',
                              height: '100%',
                              width: '100%',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center'
            }}
          />
        </Button>
              )}
    </div>
  </AntForm>
);

export const SearchForm = AntForm.create({ name: 'search-form' })(Form);
